import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from './useSignupData';
import { GuessedPrefillHelperText } from '../views-components/GuessedPrefillHelperText';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
export const ValidationTextWrapper = styled.div.withConfig({
  displayName: "useInputValidation__ValidationTextWrapper",
  componentId: "sc-1u74gt5-0"
})([".is--text--error{color:#bf2434 !important;}"]);
const ValidationTextHelperMargin = styled.div.withConfig({
  displayName: "useInputValidation__ValidationTextHelperMargin",
  componentId: "sc-1u74gt5-1"
})(["margin-top:0.625rem;margin-bottom:1.3125rem;"]);
export const useInputValidation = ({
  dataKey,
  customValidationError
}) => {
  const {
    isInvalid,
    errorMessage
  } = useSignupData(dataKey);
  const getValidationText = () => {
    if (errorMessage && isInvalid && customValidationError) {
      return customValidationError;
    }
    if (errorMessage && isInvalid) {
      // short term solution
      const shouldShowDefaultMessaging = [Data.FirstName, Data.LastName].includes(dataKey) && !isValidI18nKey(errorMessage);
      return /*#__PURE__*/_jsx(ValidationTextWrapper, {
        children: /*#__PURE__*/_jsx(Small, {
          use: "error",
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-selenium": `${dataKey}_validation_message`,
            message: shouldShowDefaultMessaging ? `data.${dataKey}.error.invalid` : errorMessage
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(ValidationTextHelperMargin, {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        weight: "regular",
        children: /*#__PURE__*/_jsx(GuessedPrefillHelperText, {
          dataKey: dataKey
        })
      })
    });
  };
  return {
    getValidationText
  };
};